<template>
  <div class="zj-emergency-realtimecall">
    <div class="zj-emergency-realtimecall-header">
      <span class="header-title">视频连线</span>
      <div class="arrow-pic"></div>
      <div class="icon-spread" @click="handleSpreadVideoCall"></div>
    </div>
    <div class="zj-emergency-realtimecall-add-contact-btn" @click="isAddContactVisible=true">+ 添加联系人</div>
    <div class="zj-emergency-realtimecall-contact">
      <div v-show="!joined" class="empty-contact">
        <div class="empty-contact-pic"></div>
        <div class="empty-contact-tips">当前暂无联系人</div>
      </div>
      <div v-show="joined" class="has-contact video-list">
        <div class="contact-container-wrapper">
          <div class="contact-container" ref="remoteVideos">
            <div class="local video-wrapper">
              <div class="video-wrapper-outter">
                <video ref="localVideo" autoplay muted>
                  <div class="video-wrapper-inner"></div>
                </video>
              </div>
              <div class="video-control-btns">
                <div class="mute-btn" @click="handleMuteLocal">
                  <i :class="{ 'el-icon-microphone': !mute, 'el-icon-turn-off-microphone':mute }"></i>
                  <span>{{ !mute? '静音': '取消' }}</span>
                </div>
                <div class="stop-btn" @click="handleDeleteRoom">
                  <i class="el-icon-switch-button"></i>
                  <span>关闭</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      class="emergencyoperations-dialog thin"
      custom-class="bg2"
      top="15vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isAddContactVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <ZJEmergencyComponentAddContact
        v-bind:ExecutId="ExecutId"
        :roomId="roomId"
        :pwd="pwd"
        @handlerclose="isAddContactVisible=false"
      />
    </el-dialog>
    <el-dialog
      class="emergencyoperations-dialog video-monitor"
      custom-class="bg3"
      top="20vh"
      :modal-append-to-body="false"
      :append-to-body="true"
      :visible.sync="isRealtimeCallWinVisiable"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :destroy-on-close="true"
    >
      <ZJEmergencyComponentRealtimeCallWin
        :allVideos="allVideos"
        :mute="mute"
        v-bind:ExecutId="ExecutId"
        :roomId="roomId"
        :pwd="pwd"
        @handlerclose="isRealtimeCallWinVisiable=false"
        @handleMute="handleMute($event)"
        @handleMuteLocal="handleMuteLocal"
        @handleKick="handleKick($event)"
        @handleDeleteRoom="handleDeleteRoom"
      />
    </el-dialog>
  </div>
</template>

<script>
import ZJApp from "../../../../../../app";
import ZJEmergencyComponentAddContact from "./Component-AddContact";
import ZJEmergencyComponentRealtimeCallWin from "./Component-RealtimeCallWin";

const ZJMeeting = ZJApp.ZJMeeting;

export default {
  name: "ZJEmergencyRealtimecall",
  componentName: "ZJEmergencyRealtimecall",
  components: {
    ZJEmergencyComponentAddContact,
    ZJEmergencyComponentRealtimeCallWin,
  },
  props: {
    ExecutId: {
      type: String,
      required: true,
    },
    roomId: {
      type: String,
    },
    pwd: {
      type: String,
    },
  },
  data: function () {
    return {
      nick: "指挥中心",
      joined: false,
      mute: false,
      frontCam: true,
      isAddContactVisible: false,
      isRealtimeCallWinVisiable: false,
      allVideos: [],
    };
  },
  created() {
    this.$on("onJoinRoomRequestReceived", this.onJoinRoomRequestReceived);
  },
  mounted() {
    const that = this;
    const signalServer = this.CNF("meetingCenter.signalServer");
    if (!signalServer) {
      this.$message.error("未配置信令服务器");
      return;
    }

    const remoteVideos = {
      appendPeerStream: function (video, peer) {
        let div = document.createElement("div");
        let id = "zj-meeting-remote-peer-" + peer.id;
        div.className = "video-wrapper";
        div.id = id;
        that.$refs.remoteVideos.appendChild(div);

        let wrapperOutterDiv = document.createElement("div");
        wrapperOutterDiv.className = "video-wrapper-outter";
        div.appendChild(wrapperOutterDiv);
        wrapperOutterDiv.appendChild(video);

        let videoControlBtnsDiv = document.createElement("div");
        videoControlBtnsDiv.className = "video-control-btns";
        div.appendChild(videoControlBtnsDiv);
        videoControlBtnsDiv.innerHTML =
          '<div class="mute-btn">' +
          '   <i class="el-icon-microphone"></i><span>静音</span>' +
          "</div>" +
          '<div class="stop-btn">' +
          '   <i class="el-icon-switch-button"></i><span>关闭</span>' +
          "</div>";

        let mutebtn = videoControlBtnsDiv.querySelector(".mute-btn");
        mutebtn.onclick = function () {
          let icon = mutebtn.querySelector("i");
          if (icon) {
            if (icon.className.indexOf("el-icon-microphone") != -1) {
              //静音
              that.mc.mute({
                target: peer.id, // 目标 Peer 的 sessionId。all, 表示全体静音。
              });
            } else {
              //取消静音
              that.mc.unmute({
                target: peer.id,
              });
            }
          }
        };

        let kickbtn = videoControlBtnsDiv.querySelector(".stop-btn");
        kickbtn.onclick = function () {
          //踢出房间
          that.mc.kick({
            target: peer.id,
          });
        };

        that.allVideos.push({
          id: peer.id,
          video: video,
          muted: false,
        });
      },
      removePeerStream: function (video, peer) {
        let id = "zj-meeting-remote-peer-" + peer.id;
        let div = that.$refs.remoteVideos.querySelector("#" + id);
        that.$refs.remoteVideos.removeChild(div);

        that.allVideos.forEach(function (item, index, arr) {
          if (item.id === peer.id) {
            arr.splice(index, 1);
          }
        });
      },
      setMute: function (id, value) {
        // that.$message({
        //   message: "静音" + id + value,
        //   type: "warning",
        // });
        let containerId = "zj-meeting-remote-peer-" + id;
        let container = that.$refs.remoteVideos.querySelector(
          "#" + containerId
        );
        let mutebtn = container.querySelector(".mute-btn");
        if (mutebtn) {
          let span = mutebtn.querySelector("span");
          if (span) {
            span.innerHTML = value ? "取消" : "静音";
          }

          let icon = mutebtn.querySelector("i");
          if (icon) {
            icon.className = value
              ? "el-icon-turn-off-microphone"
              : "el-icon-microphone";
          }
        }
      },
    };

    this.mc = new ZJMeeting.MeetingCenter({
      debug: false,
      signalServer: signalServer,
      autoConnect: false,

      localVideoEl: this.$refs.localVideo,
      remoteVideosEl: remoteVideos,
      autoRemoveVideos: true,
      autoRequestMedia: false,
      enableDataChannels: false,
      media: {
        audio: true,
        video: {
          facingMode: this.frontCam ? "user" : "environment", // 前置摄像头/默认摄像机
        },
      },
    });

    //被踢出房间
    this.mc.on("kick", function () {
      that.$message({
        message: "您被踢出了房间",
        type: "warning",
      });
    });

    //解散房间
    this.mc.on("deleteRoom", function () {
      that.$message({
        message: "房间已经被解散",
        type: "warning",
      });
    });

    this.mc.on("error", function (e) {
      that.$message.error(e.toString());
    });

    this.mc.on("readyToCall", function () {
      console.log(that.roomId + that.pwd + that.nick);
      that.mc.joinRoom({
        name: that.roomId, // 房间名称
        pwd: that.pwd, // 密码
        nick: that.nick, // 昵称
      });

      that.allVideos.push({
        id: "localVideo",
        video: that.$refs.remoteVideos.querySelector("video"),
        muted: false,
      });

      console.log("join success");
    });

    this.mc.on("leftRoom", function () {
      setTimeout(function () {
        that.mc.disconnect();
      }, 0);
      that.mc.stopLocalVideo();
      that.mute = false;
    });

    //本地开麦
    this.mc.on("audioOn", function () {
      that.mute = false;
    });

    //本地关麦
    this.mc.on("audioOff", function () {
      that.mute = true;
    });

    //远端关麦
    this.mc.on("mute", function (e) {
      remoteVideos.setMute(e.id, true);
    });

    //远端开麦
    this.mc.on("unmute", function (e) {
      remoteVideos.setMute(e.id, false);
    });
  },
  destroyed() {
    if (this.mc) {
      this.mc.destroy();
      this.mc = null;
    }
  },
  methods: {
    onJoinRoomRequestReceived: function (args) {
      this.handleJoinRoom(args);
    },
    // eslint-disable-next-line no-unused-vars
    handleJoinRoom(args) {
      if (this.joined) {
        return;
      }
      this.joined = true;
      this.mc.config.media.video.facingMode = this.frontCam
        ? "user"
        : "environment";

      this.mc.startLocalVideo();
      this.mc.connect();
    },

    handleMute: function (muteInfo) {
      let peerid = muteInfo.id;
      let muted = muteInfo.muted;

      // this.$message({
      //   message: "点击静音" + peerid + muted,
      //   type: "warning",
      // });
      if (muted) {
        this.mc.unmute({
          target: peerid, // 目标 Peer 的 sessionId。all, 表示全体静音。
        });
      } else {
        this.mc.mute({
          target: peerid, // 目标 Peer 的 sessionId。all, 表示全体静音。
        });
      }
      this.allVideos[muteInfo.index - 1].muted = !muted;
    },
    handleMuteLocal: function () {
      if (this.mute) {
        this.mute = false;
        this.mc.unmute();
      } else {
        this.mute = true;
        this.mc.mute();
      }
    },
    handleKick: function (peerid) {
      //踢出房间
      this.$message({
        message: peerid,
        type: "warning",
      });
      this.mc.kick({
        target: peerid,
      });
    },
    handleSpreadVideoCall: function () {
      this.isRealtimeCallWinVisiable = true;
    },
    handleDeleteRoom() {
      this.allVideos = [];
      this.joined = false;
      this.mc.deleteRoom();
    },
  },
};
</script>

